<div class="modal-header">
    <h5 class="modal-title">Discard changes?</h5>
</div>
<div class="modal-body text-muted">
    You will lose your changes.
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="confirm()">Discard</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
